import React from 'react';

export function renderBanner(bannerImage: string | null, bannerPageHeading: string | null) {
	if (bannerImage) {
		bannerImage = bannerImage.replace(/\\/g, '/');
		bannerImage = "url('" + bannerImage + "')";
	} else {
		return null;
	}

	return (
		<div className="hawk-listing-banner" style={{ backgroundImage: bannerImage }}>
			<div className="roc-container">
				<h1 className="listing-banner-title">{bannerPageHeading}</h1>
			</div>
		</div>
	);
}
